export default "## MdPreviewer\n\nMdPreviewer 实时预览 markdown 文档，将自己制作的 markdown 文档翻译成 html 标签，极大方便开发人员制作说明文档统一排版及格式，通过属性 md 指定 markdown 文件。\n"